var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBackCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    transform: "matrix(-1 0 0 1 48.543 .303)",
    fill: "#000",
    fillOpacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.523 23.596a1 1 0 000 1.414l6.364 6.363a1 1 0 101.414-1.414l-5.656-5.656 5.656-5.657a1 1 0 10-1.414-1.414l-6.364 6.364zm17.33 1.707a1 1 0 100-2v2zm-16.623 0h16.623v-2H16.23v2z",
    fill: "#fff"
  })));
}

export default SvgBackCircle;